import { ISO3166Alpha3 } from '../../indigofair/iso3166/ISO3166Alpha3';
import { SettingConst } from '../../types';

/**
 * List of countries (ISO three letter country codes) that should use Adyen for brand onboarding
 */
export const ADYEN_BRAND_ONBOARDING_COUNTRIES =
  'ADYEN_BRAND_ONBOARDING_COUNTRIES' as SettingConst<
    'ADYEN_BRAND_ONBOARDING_COUNTRIES',
    Array<keyof typeof ISO3166Alpha3>,
    'MAKER' | 'ADMIN' | 'HELP_CENTER'
  >;
